import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { BusinesscoItem, LogisticService } from '@app/services/logistic.service';
import { SellerGet, SellerLookupItem, SellerService } from '@app/services/seller.service';

@Component({
    selector: 'tt-seller',
    templateUrl: './seller.component.html',
    styleUrls: ['./seller.component.css'],
    standalone: false
})
export class SellerComponent implements OnInit, OnChanges {
    @Input()
    public sellerId?: string;

    @Output()
    public onSave = new EventEmitter<void>();

    public page?: SellerGet;

    public companies: BusinesscoItem[] = [];

    public saving = false;

    public readonly tablet: MediaQueryList;

    constructor(
        private seller: SellerService,
        private logistic: LogisticService,
        private modal: ModalService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.tablet = layout.getMediaQueries().tablet;
    }

    private async load(id: string): Promise<void> {
        if (!id) return;

        await Promise.all([
            this.seller.getSeller(id).then(page => this.page = page),
            this.logistic.getCompanies('0').then(companies => this.companies = companies)
        ]);
    }

    public sellerSearch = (params?: { value?: string }): Promise<SellerLookupItem[]> => {
        return this.seller.lookup(params?.value ?? '');
    }

    public onSearchChange(value: string): void {
        if (!this.page) return;

        this.page.labour_no = '0';
        this.page.seller_name = value;
    }

    public selectSeller(item?: SellerLookupItem): void {
        if (!this.page) return;

        this.page.labour_no = item?.labour_no ?? '0';
        this.page.seller_name = item?.labour_name ?? this.page.seller_name;
    }

    public async saveChanges() {
	    if (!this.page || this.saving) return;
	
	    try {
		    this.saving = true;
		
		    const { errorcode, errormessage } = await this.seller.save(this.page);
		
		    if (errorcode !== '0') {
			    this.modal.show({ 
				    type: 'warning', 
				    title: 'error', 
				    translateTitle: true, 
				    message: errormessage 
			    });
		    } else {
			    if (this.tablet.matches) {
                    this.onSave.emit();
                } else {
                    this.navigator?.back();
                }
		    }
	    } finally {
		    this.saving = false;
	    }
    }
	
    public async ngOnInit(): Promise<void> {
        this.sellerId = this.sellerId ?? String(this.navigator?.params['seller_id'] ?? '');

        await this.load(this.sellerId);
    }

    public async ngOnChanges(changes: SimpleChanges): Promise<void> {
        const change = changes['sellerId'];

        if (change && !change.firstChange && change.currentValue) await this.load(change.currentValue);
    }
}
